import YYSlider from './slider'

export default YYSlider